<!--
 * @Author: 陈绍斌 1748362428@qq.com
 * @Date: 2023-05-26 14:23:16
 * @LastEditors: pliybird
 * @LastEditTime: 2023-06-13 14:04:08
 * @FilePath: \Vyung.Portal.Front\src\views\IndustrySolution\components\EducationAdvantage.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!--
 * @Description: 教育行业：方案优势
-->
<template>
    <div class="content">
        <div class="circle left"></div>
        <div class="circle right"></div>
        <div class="d-flex plr--30">
          <div class="item" :class="{'reverse':index%2===1}"  v-for="(item,index) in advantageList" :key="index">
            <div class="num">{{ ('0'+(index + 1)).slice(-2) }}</div>
            <div class="description " :class="{'en':$i18n.locale === 'en_US'}">
              {{ item.description }}
            </div>
          </div>
        </div>
    </div>
</template>

<script>

export default {
  name: "RetailFMCGAdvantage",
  computed:{
    advantageList(){
      return [
        {
          description:this.$t("solution.education.advantages.tab.tab01")
        },
        {
          description:this.$t("solution.education.advantages.tab.tab02")
        },
        {
          description:this.$t("solution.education.advantages.tab.tab03")
        },
        {
          description:this.$t("solution.education.advantages.tab.tab04")
        },
        {
          description:this.$t("solution.education.advantages.tab.tab05")
        },
      ]
    }
  },
  data () {
    return {
     
    };
  },
  methods: {},
};
</script>